import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { FlexBetween } from '../../../global/commonStyle';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const Box = styled.div`
  max-width: 662px;
  width: 100%;
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
`;
const First = styled.div`
  padding: var(--space-16);
  ${FlexBetween}
  gap: var(--space-20);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const Top = styled.div`
  width: 136px;
  height: 9px;
  border-radius: var(--border-radius-8);
  background-color: var(--background-muted);
`;

const Bottom = styled.div`
  width: 280px;
  height: 9px;
  border-radius: var(--border-radius-8);
  background-color: var(--background-muted);
`;

const Right = styled.div`
  width: 18px;
  height: 18px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const Title = styled.div`
  color: var(--text-primary);
  ${Typography.heading_md}
`;

export { Main, Box, First, Left, Right, Top, Bottom, Content, Title };
